import { render, staticRenderFns } from "./MypageSwitchToPaidPlanPage.vue?vue&type=template&id=bdccf14e"
import script from "./MypageSwitchToPaidPlanPage.vue?vue&type=script&lang=ts"
export * from "./MypageSwitchToPaidPlanPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports